import { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { AiOutlineDelete } from "react-icons/ai";
import { FaCircleXmark, FaPlus } from "react-icons/fa6";
import { Button, Checbox, Input } from "../CustomComponents";
import LoadingButton from "../CustomComponents/LoadingButton";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import _ from "lodash";
import { Padding } from "@mui/icons-material";
const AddTravelModal = ({
  handleModalClose,
  heading,
  data,
  isLoading,
  onSubmit = () => {},
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const color = watch("color");
  console.log(color);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    if (data?.image_url) {
      setPreviewUrl(data.image_url);
      setValue("name", data?.name);
      setValue("color", data?.color);
      setValue("prompt", data?.prompt);
      setValue("image_url", data?.image_url);
    }
  }, [data]);

  const handleImageChange = (e, onChange) => {
    const file = e.target.files[0];
    setPreviewUrl(file);
    if (file) {
      //   setPreviewUrl(URL.createObjectURL(file));
      onChange(file);
    }
  };

  console.log(previewUrl);

  return (
    <div>
      <ModalContainer handleClose={handleModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between">
            <p className="fs-4 fw-medium m-0">{heading}</p>
            <span className="bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                size={25}
                role="button"
                onClick={handleModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)} className="w-100">
            {/* Image Upload */}
            <Controller
              control={control}
              name="image_url"
              render={({ field: { onChange } }) => (
                <div className="mb-3 d-flex flex-column">
                  <label htmlFor="uploadimage" className="cursor-pointer">
                    <img
                      src={
                        previewUrl
                          ? _.isString(previewUrl)
                            ? previewUrl
                            : URL.createObjectURL(previewUrl)
                          : "/images/placeholder.jpg"
                      }
                      alt="Preview"
                      className="mt-2"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        borderRadius: "20px",
                      }}
                    />
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control mt-1"
                    onChange={(e) => handleImageChange(e, onChange)}
                    hidden
                    id="uploadimage"
                  />
                </div>
              )}
            />
            <div className="flex-between w-100">
              <p className="fs-7 fw-bold">Select Color</p>
              <p className="" style={{ color: color }}>
                {color}
              </p>
            </div>
            {/* Color */}
            <Controller
              control={control}
              name="color"
              render={({ field }) => (
                <Input
                  placeholder="Color"
                  type="color"
                  classes="mb-3 p-0 w-100"
                  {...field}
                />
              )}
            />

            {/* Name */}
            <Controller
              control={control}
              name="name"
              render={({ field }) => (
                <InputGroup className="mb-3">
                  <Input placeholder="Name" type="text" {...field} />
                </InputGroup>
              )}
            />

            {/* Prompt */}
            <Controller
              control={control}
              name="prompt"
              render={({ field }) => (
                <Input
                  classes="mt-2 mb-3"
                  as="textarea"
                  rows={3}
                  type="textarea"
                  placeholder="Prompt"
                  {...field}
                />
              )}
            />

            <Button
              text={
                <>{isLoading ? <LoadingButton /> : data ? "Update" : "Add"}</>
              }
              classes="mt-3 mb-2"
              type="submit"
            />
          </Form>
        </div>
      </ModalContainer>
    </div>
  );
};

export default AddTravelModal;
